import { type ReactNode } from 'react';
import { formatDate } from '@utils/dateFormatUtils';
import { SourceInfoTile } from '@components/SourceInfoTile/SourceInfoTile';
import { formatBoolean } from '@components/cve/cve-details/utils/cveDetailsFormatters';
import { type ComponentSourceRaw } from '@gql/graphql';
import { type Maybe } from '@models/Maybe';

export interface ExternalSourcesContentProps {
    sources: ComponentSourceRaw[];
}

function isEolReached(eolDate: Maybe<string>): boolean {
    if (!eolDate) return false;
    return new Date(eolDate).getTime() < Date.now();
}

export function ExternalSourcesContent({
    sources,
}: ExternalSourcesContentProps): ReactNode {
    return (
        <div className="grid">
            {sources.map((source) => (
                <div key={source.id} className="col-4">
                    <SourceInfoTile
                        title={source.sourceName}
                        className="h-full w-full"
                        fields={[
                            { label: 'Vendor', value: source.vendorName },
                            { label: 'Name', value: source.componentName },
                            {
                                label: 'Version',
                                value: source.version ?? '-',
                            },
                            {
                                label: 'EOL Date',
                                value: formatDate(source.eolDate) || '-',
                            },
                            {
                                label: 'EOL Reached',
                                value: formatBoolean(
                                    isEolReached(source.eolDate),
                                ),
                            },
                        ]}
                    />
                </div>
            ))}
        </div>
    );
}
